const Colors = {
    Elmt: {
        Black: 0x000000,
        White: 0xFFFFFF,
        Purple: 0xc82c68,
        Blue: 0x1F3874,
        Orange: 0xf36810,
        DarkBlue: 0x153878,
        Green: 0x78C647,
        Red: 0xEF3C25,
        Beige: 0xF3F3EC,
        lightGrey: 0xCCCCCC,
        DarkGrey: 0x777777,
        BackColor: 0xE6E6DD,
        DarkBeige: 0xFFCEAD,
        LightRed: 0xDE005D
    },
    Text: {
        Black: "#000000",
        White: "#FFFFFF",
        Purple: "#c82c68",
        Blue: "#1F3874",
        Orange: "#f36810",
        DarkBlue: "#153878",
        Green: "#78C647",
        Red: "#EF3C25",
        Beige: "#F3F3EC",
        lightGrey: "#CCCCCC",
        DarkGrey: "#777777",
        BackColor: '#E6E6DD',
        DarkBeige: '#FFCEAD',
        LightRed: '#DE005D'
    }
}

export {
    Colors
}